import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { appDescriptionLenses } from 'root/src/client/logic/app/lenses'

const { viewSliderWidth } = appDescriptionLenses

export default (state, { moduleId }) => viewSliderWidth(moduleId, moduleDescriptions)
